import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbErmodelApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbErmodel';
    }

    public getDbErModelByDbId(dbId: number) {
        return this.send({ dbId }, 'getDbErModelByDbId', Methods.GET);
    }

    /**
     * 保存修改数据
     * @param datas 
     * @returns 
     */
    public dbErmodelSaveOrUpdate(datas) {
        return this.send(datas, 'dbErmodelSaveOrUpdate', Methods.POST);
    }

}